import React from "react";
import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import api from "@/lib/apiClient";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { BookOpen, Video, FileText } from "lucide-react";

const HEADER = "https://images.unsplash.com/photo-1578496479531-32e296d5c6e1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

export default function Materials() {
  const { data: materials = [], isLoading } = useQuery({ queryKey: ["materials"], queryFn: () => api.get("/materials").then((r) => r.data) });

  return (
    <div className="space-y-6">
      <div className="relative instrument-surface rounded-md overflow-hidden">
        <img src={HEADER} alt="Laboratorium" className="absolute inset-0 w-full h-full object-cover opacity-30" />
        <div className="relative z-10 p-8">
          <h1 className="font-heading font-extrabold text-3xl text-white flex items-center gap-2">
            <BookOpen className="h-7 w-7" /> Materi Pembelajaran
          </h1>
          <p className="text-zinc-300 mt-1">Pelajari dasar-dasar teori HPLC sebelum ke laboratorium.</p>
        </div>
      </div>

      {isLoading && <p className="text-muted-foreground">Memuat…</p>}

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {materials.map((m) => (
          <Card key={m.id} className="rounded-md overflow-hidden flex flex-col" data-testid={`material-${m.id}`}>
            {m.image_url ? (
              <img src={m.image_url} alt={m.title} className="h-36 w-full object-cover" />
            ) : (
              <div className="h-36 w-full bg-accent flex items-center justify-center"><BookOpen className="h-10 w-10 text-primary/40" /></div>
            )}
            <div className="p-4 flex flex-col flex-1">
              <div className="flex items-center gap-2 text-xs font-data text-muted-foreground mb-1">
                <span>Bab {m.order}</span>
                {m.video_url && <Video className="h-3.5 w-3.5" />}
                {m.pdf_url && <FileText className="h-3.5 w-3.5" />}
              </div>
              <h3 className="font-heading font-bold text-base mb-2">{m.title}</h3>
              <p className="text-sm text-muted-foreground line-clamp-3 flex-1">{m.body}</p>
              <Button asChild variant="outline" size="sm" className="mt-3 w-full" data-testid={`read-${m.id}`}>
                <Link to={`/materials/${m.id}`}>Baca</Link>
              </Button>
            </div>
          </Card>
        ))}
      </div>

      {materials.length === 0 && !isLoading && <p className="text-muted-foreground">Belum ada materi dipublikasikan.</p>}
    </div>
  );
}
